{
    "use strict";

    document.addEventListener("DOMContentLoaded", () => {
        const items = document.querySelectorAll("template.side-menu-adjust");
        if(!items.length) return;
        let template = items[0];

        items.forEach(item => {
            if(item.classList.contains("product-adjust")){
                template = item;
            }
        });

        const content = template.content.cloneNode(true);
        const parent = document.querySelector("aside.side-bar");
        if(!parent) return;
        parent.appendChild(content);

        document.querySelectorAll(".main-side-bar").forEach(e => {
            e.classList.add("hidden");
        });
        const sideBar = document.getElementById('side-bar-adjust');
        document.getElementById('menu-from-side-bar-adjust').appendChild(sideBar.cloneNode(true));

        const sideBarToggleBtns = document.querySelectorAll('#side-bar-adjust .sidebar-btnarea .toggle-btn');
        sideBarToggleBtns.forEach(item => {
            item.addEventListener('click', e => {
                e.currentTarget.parentNode.parentNode.dataset.open = e.currentTarget.dataset.toggleBrandname;
            });
        });
        const sideBarToggle = document.querySelectorAll('#side-bar-adjust .item-top div.toggle');
        sideBarToggle.forEach(item => {
            item.addEventListener('click', e => {
                const root = e.currentTarget.parentNode.parentNode;
                root.classList.toggle('open');
                const ul = root.querySelector('ul');
                if(root.classList.contains('open') && ul){
                    ul.style.height = 'auto';
                    let h = ul.offsetHeight;
                    ul.style.height = h + 'px';
                    ul.animate(
                        {
                            height: [ 0, h + 'px' ]
                        },
                        {
                            duration: 100,
                        }
                    );
                    ul.style.height = 'auto';
                }else{
                    let h = ul.offsetHeight;
                    ul.style.height = h + 'px';
                    ul.animate(
                        {
                            height: [ h + 'px', 0 ]
                        },
                        {
                            duration: 100,
                        }
                    );
                    ul.style.height = 0;
                }
            });
        });
    });
}